// extracted by mini-css-extract-plugin
module.exports = {"header":"layout-module_header_3InyX","tabsCard":"layout-module_tabsCard_217eH","iframe":"layout-module_iframe_21dAP","footer":"layout-module_footer_33unY"};